import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TextField } from "@mui/material";
import { UtilizationDistributionStyle,UtilizationDistributionTextField } from './UtilizationDistributionStyled';
export const UtilizationDistribution = ({ headers, rows, isEditable, onTextChange }) => {    

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 400 }} aria-label="customized table">
              
                <TableHead>
                    <TableRow>
                        {headers.map((header) => (

                            <TableCell key={header.id}>{header.label}</TableCell>
                        ))}

                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow>
                            {headers.map((cell)=>(
                                <TableCell size='small' >
                                    <UtilizationDistributionTextField sx={{width:'100px'}}>
                                        {(isEditable && cell.isEditable===true)  ? 
                                        <TextField className='forminput'  size="small" 
                                        inputProps={{ maxLength: 10 }}
                                        onChange={(e) => onTextChange(e,cell.id, e.target.value)} 
                                        defaultValue={row[cell.id]} />
                                            : isNaN(Number(row[cell.id]?.toFixed(2))) ? 0 : Number(row[cell.id]?.toFixed(2)).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits:2 }) }

                                    </UtilizationDistributionTextField>
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default UtilizationDistribution;